import styled from "styled-components";
import { Device } from "@styles/constants";
import { Heading4CSS, LargeBodyRegularCSS, PortableTextWrapper } from "@styles/typography";

export const Container = styled(PortableTextWrapper)`
  margin: 30px 0 60px;

  @media ${Device.mediumUp} {
    margin: 60px 0;
  }

  h1,
  h2,
  h3,
  h4 {
    ${Heading4CSS}
    text-align: left;
    margin-bottom: 20px;
  }

  p {
    ${LargeBodyRegularCSS}
    margin-bottom: 0;

    + p {
      margin-top: 30px;
    }
  }
`;
